import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { RicosContext } from 'ricos-context';

import styles from '../../statics/styles/new-pair-button.rtlignore.scss';
import { NEW_PAIR_BUTTON } from '../dataHooks';
import { PlusIcon } from '../icons';

export default function NewPairButton({
  label,
  onClick,
}: {
  label: string;
  onClick: (e: React.MouseEvent | React.KeyboardEvent) => void;
}) {
  const { tabIndex } = useContext(RicosContext);

  return (
    //using 'div' element instead of 'button' to fix a bug of focus on element in Firefox in OSX
    // further reading, https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#Clicking_and_focus#Clicking_and_focus
    <div
      role="button"
      tabIndex={tabIndex}
      className={styles.new_pair_container}
      onClick={onClick}
      onKeyPress={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          onClick(e);
        }
      }}
      // DONT REMOVE THIS
      // This calls before Prosemirror focus event and prevents it
      onMouseDown={e => {
        e.preventDefault();
        e.stopPropagation();
      }}
      data-hook={NEW_PAIR_BUTTON}
    >
      <div className={styles.new_pair_button}>
        <PlusIcon />
        <label className={styles.new_pair_label}>{label}</label>
      </div>
    </div>
  );
}

NewPairButton.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};
